import service from '@/helpers/serviceGPAO'

export function login(username, password) {
  return service.post("auth/", { username, password })
}

export function currentUserInfo() {
  return service.get("/users/")
}

export function obtenirInfosFournisseur(fournisseurId) {
  return service.get("/users/" + fournisseurId + "/infos")
}

export function obtenirInfosFournisseurAdresse(fournisseurId) {
  return service.get("/users/" + fournisseurId + "/infosAdresse")
}

export function modifierInfosUser(contact) {
  return service.post("/users/modifierInfosUtilisateur", contact)
}

export function modifierInfosFournisseur(fournisseur) {
  return service.post("/users/modifier", fournisseur)
}

export function obtenirListeGenre() {
  return service.get("/users/obtenirGenres")
}

export function getContactsAgap() {
  return service.get("/users/obtenirContactsAgap")
}

export function getContactsAgapDunFournisseur(fId) {
  return service.get("/users/obtenirContactsAgapDunFournisseur/" + fId)
}




